export default __webpack_public_path__ + "static/media/books-768w.1535c7e1.avif";